import axios from "axios";

const user = {
  get: function(type, id) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json"
        },
        url: `/api/user`
      })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};

export default user;
